import React from 'react';
import {Container} from 'react-bootstrap';

const PublicLayout = ({children, title = 'Astuce Tiers Payant'}) => (
    <div style={{minHeight: '100vh', background: '#f8f9fa'}}>
        <header style={{background: '#fff', borderBottom: '1px solid #dee2e6', padding: '1rem 0'}}>
            <Container>
                <h4 className="mb-0">{title}</h4>
            </Container>
        </header>
        <main className="py-4">
            <Container>{children}</Container>
        </main>
    </div>
);

export default PublicLayout;
